import { Link } from 'react-router-dom';
import guideAndReportsItems from '../../constants/guideAndReportsItems';
import '../ContentLibraryListing/ContentLibraryList.css';
import LazyImage from '../LazyImage';

const GuidesAndReportsList = ({ category }) => {
  const shuffledConentLibraryItems = guideAndReportsItems;

  return (
    <div className="caseStudiesContainer contentLibrary guidesAndReports">
      {shuffledConentLibraryItems.map((item, index) => (
        <Link to={`/report-and-guides-details?item=${item.url}`} key={index}>
          <div className="frame-parent174">
            <LazyImage className="frame-child108" src={item.image} alt={item.title} />
            <div className="gudesAndReportsListingContent">
              <div className={`ellipse-parent7 ${item.category}`}>
                <div className={`slow-moving-consumer-goods9 ${item.category}`}>{item.category}</div>
              </div>
              <div className="momax-case-study1">{item.title}</div>
              <div className="conversion-rate-from5">{item.shortDescription}</div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default GuidesAndReportsList;
